import { SwipeActionButtonProps } from "./types"
import React from "react"
import Icon from "~widgets/icon"
import styled from '~/ui/styled'

const ActionButton = styled.button<{ $bg: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  height: 100%;
  min-width: 60px;
  padding: 0 4px;
  border: none;
  cursor: pointer;
  pointer-events: auto;
  background-color: ${({ $bg }) => $bg};
`

const ButtonText = styled.span`
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes.xs};
  color: white;
  margin-top: 4px;
`

const SwipeableActionButton: React.FC<SwipeActionButtonProps> = ({
  text,
  color,
  onClick,
  icon,
}) => (
  <ActionButton type="button" $bg={color} onClick={onClick}>
    {icon && <Icon name={icon} color="white" />}
    <ButtonText>{text}</ButtonText>
  </ActionButton>
)

export default SwipeableActionButton
